module.exports = __webpack_public_path__ + "static/img/Section4.72ffc07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Section4.png
// module id = oQVb
// module chunks = 1